import ChatBody from './ChatBody';

export default function ChatFloating({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  if (!open) return null;
  return (
    <div className="floating-panel">
      <div className="floating-head">
        <span>Chat direct</span>
        <button className="icon-btn" onClick={onClose} style={{ color: '#fff' }}>
          ×
        </button>
      </div>
      <ChatBody />
    </div>
  );
}
